import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { BsButton } from '../../collection/bootstrap/BootstrapComponents';
import DataTable from '../../collection/DataTable';
import TableHandler from '../../collection/TableHandler';
import ConveniosFilter from '../../components/filters/ConveniosFilter';
import ConvenioModal from '../../components/modals/ConvenioModal';
import FloatingAddButton from '../../components/project/FloatingAddButton';
import { apiDelete, apiForm } from '../../utils/api';
import { sortableString, generateFormData } from '../../utils/functions';

export default function Convenios(props) {
    // filter
    const defaultFilter = {
        nombre: null,
        ano:null
    };
    let filter = generateFormData(defaultFilter);

    // api calls
    const updateData = async newFilter => {
        filter = newFilter ? newFilter : filter;
        return await apiForm("convenios/table", filter);
    };
    const deleteRow = async id => await apiDelete("convenios/delete/" + id);

    // render
    return <>
        <h2>Convenios</h2>
        <TableHandler
            onUpdate={updateData}
            onDelete={deleteRow}
            elementText="el convenio">
            <ConveniosFilter
                className="my-3" fem
                defaultValue={defaultFilter} />
            <ConveniosTable />
        </TableHandler>
    </>;
}

function ConveniosTable(props) {
    // table columns
    const columns = [
        {
            name: "Año",
            selector: row => row.Ano,
            format: row => row.Ano,
            sortable: true,
        },
        {
            name: "Nombre",
            selector: row => sortableString(row.Name),
            format: row => row.Name,
            sortable: true,
            right: true
        },
        {
            name: "Días de vacaciones",
            selector: row => row.NumDiasVacaciones,
            sortable: true,
            right: true
        },
        {
            name: "Jornada anual",
            selector: row => row.JornadaAnual,
            format: row => row.JornadaAnual + "h",
            sortable: true,
            right: true
        },
        {
            name: "Días de convenio",
            selector: row => row.NumDias,
            sortable: true,
            right: true
        }
    ];
    // table buttons
    const buttons = <>
        <BsButton variant="secondary" size="sm" onClick={props.onEdit}><FontAwesomeIcon icon={faEdit} /></BsButton>
        <BsButton variant="danger" size="sm" onClick={props.onDelete}><FontAwesomeIcon icon={faTrash} /></BsButton>
    </>;

    // render
    const name = row => `${row.Name} - ${row.Ano}`;
    return <>
        <DataTable responsive columns={columns} data={props.data} rowname={name} buttons={buttons} pagination />
        {props.formOpen && (
            <ConvenioModal
                show={props.formOpen}
                onHide={props.onFormClose}
                idConvenio={props.formId}
            />
        )}
        <FloatingAddButton onClick={props.onNew} />
    </>;
}
